import { ReactNode, useMemo, useState } from 'react';
import { Field, FormikProps, FastField } from 'formik';
import { Box, Grid, Typography } from '@mui/material';

import { CommonButtonWrapper } from '@styles/CommonStyles';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { LightTooltip } from '@shared/components/grid/GridCell';
import { TextInputField } from '@shared/fields/TextInputField';
import { PageContent } from '@styles/ContactManager/WorkflowDetailsStyles';

import { sortArray } from '@shared/utils/helpers';
import { IStepReason } from '../../../../interfaces';
import { ReasonsValues } from './ReasonsModal';

interface ReasonsTableProps extends Partial<FormikProps<ReasonsValues>> {
  handleClose: () => void;
  currentReasons: IStepReason[];
  matchedReasons: IStepReason[];
}

export const ReasonsModalForm = ({ handleClose, currentReasons, setFieldValue, matchedReasons }: ReasonsTableProps) => {
  const refinedCurrentReasons = useMemo(() => {
  const stepReasons = sortArray(currentReasons.slice(), 'label', 'asc', true);   

  const itemIndex = stepReasons.findIndex((item) => item.label.toLowerCase() === 'other');

    if (itemIndex !== -1) {
      const item = stepReasons.splice(itemIndex, 1); // Remove the item from its current position
      stepReasons.push(item[0]); // Add the item to the end of the array
    }
    return stepReasons;
  }, []);

  const [reasonsState, setReasonsState] = useState<{ [key: string]: boolean }>({});
  const [showTextBox, setShowTextBox] = useState<boolean>(false);

  const onChangeReason = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReasonsState({
      ...reasonsState,
      [e.target.name]: e.target.checked,
    });
    setFieldValue && setFieldValue(e.target.name, [e.target.checked, e.target.id]);
    if (e.target.id.toLowerCase()?.trim() === 'other') {
      e.target.checked ? setShowTextBox(true) : setShowTextBox(false);
    }
  };

  const formConfig: ReactNode[] = useMemo(() =>
    refinedCurrentReasons.map((item: IStepReason, index: number) => {
      const isLabelChecked = matchedReasons.find((reason: IStepReason) => reason.label === item.label)?.isAutoSelected || false;
      return (
        <Box key={index} sx={{ display: 'flex', paddingLeft: '5px' }}>
          <Field
            type="checkbox"
            label={item?.label}
            id={item?.label}
            name={item?.id}
            defaultChecked={isLabelChecked}
            checked={reasonsState[item?.id]}
            onChange={onChangeReason}
          />
          <LightTooltip title={item?.description} placement="top-start">
            <Typography ml={1} sx={{fontWeight: item.isLcCondition? 'bold':'regular' }}>{item?.label}</Typography>
          </LightTooltip>
        </Box>
      );
    }), [refinedCurrentReasons, matchedReasons, onChangeReason]);

  return (
    <>
      <PageContent>
        <Grid container spacing={4}>
          <Grid item md={12}>
            {formConfig}
            {showTextBox ? (
              <FastField
                name="description"
                label="Description"
                style={{ marginTop: '25px' }}
                component={TextInputField}
              />
            ) : null}
          </Grid>
        </Grid>
      </PageContent>

      <CommonButtonWrapper style={{ marginTop: '40px' }}>
        <CancelButton width='60px' onClick={handleClose} />
        <SaveButton width='60px' />
      </CommonButtonWrapper>
    </>
  );
};
